import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const employmentRelationshipDescriptor = defineListFilter({
  definition: {
    id: FilterId.EMPLOYMENT_RELATIONSHIP,
    name: 'Employment Type',
    selectionListId: 'employment_relationship',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_EMPLOYMENT_RELATIONSHIP },
});
